import Common from '../../../Common';

const Member = class extends Common {
	async browse(userId: number | string) {
		return this.get(`/user/${userId}/ringgroup/member`);
	}
}

export default Member
